import { useState, useCallback } from 'react';
import { pw9220Api, F910, F911 } from '../../../services/pw9220Api';

export function useAttendanceHistory() {
  const [attendanceList, setAttendanceList] = useState<F910[]>([]);
  const [punchLogs, setPunchLogs] = useState<F911[]>([]);
  const [attendanceTotal, setAttendanceTotal] = useState(0);
  const [punchLogTotal, setPunchLogTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const loadAttendance = useCallback(async (params: {
    employee_code?: string;
    date?: string;
    date_from?: string;
    date_to?: string;
    page?: number;
    size?: number;
  }) => {
    setLoading(true);
    try {
      const res = await pw9220Api.listAttendance(params);
      setAttendanceList(res.data || []);
      setAttendanceTotal(res.total);
    } catch {
      setAttendanceList([]);
      setAttendanceTotal(0);
    } finally {
      setLoading(false);
    }
  }, []);

  const loadPunchLogs = useCallback(async (params: {
    employee_code?: string;
    date?: string;
    date_from?: string;
    date_to?: string;
    page?: number;
    size?: number;
  }) => {
    setLoading(true);
    try {
      const res = await pw9220Api.listPunchLogs(params);
      setPunchLogs(res.data || []);
      setPunchLogTotal(res.total);
    } catch {
      setPunchLogs([]);
      setPunchLogTotal(0);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    attendanceList,
    punchLogs,
    attendanceTotal,
    punchLogTotal,
    loading,
    loadAttendance,
    loadPunchLogs,
  };
}
